export const enum TabviewMode {
    Horizontal = "Horizontal",
    Vertical = "Vertical"
}


// WEBPACK FOOTER //
// ./src/Components/Tabview/TabviewMode.tsx